$(document).ready(function()
{
	if (false === isPALMode())
		return;
	$(document).bind('VILJoinConference', function(event, ui) {
		// when joining a conference, disable the UI items that allow changing of DSC availability
		$('.dscAvailibityUI').attr('disabled', 'disabled');
		$('.dscAvailibityUI').addClass('Disabled');
	});
	$(document).bind('VILLeaveConference', function(event, ui) {
		// when leaving a conference, enable the UI items that allow changing of DSC availability
		$('.dscAvailibityUI').removeAttr('disabled');
		$('.dscAvailibityUI').removeClass('Disabled');
	});
	/**
	 * The enumerations for the SHRecordState class in dataserver
	 * The enumeration defines what actions a given case row can perform
	 * The attributes are stored as attributes of the jQGrid <tr> elements
	 */

	jsPAL.shRecordStateColumns =
	{
		CanAssign				: {attr :'CanAssign',				downto : 'CanAssign',				actionIndex : jsPAL.cmdBar.actions.actionAssignTo},
		CanAssignBack			: {attr :'CanAssignBack',			downto : 'CanAssignBack',			actionIndex : jsPAL.cmdBar.actions.actionAssignBackToUser},
		// jsPAL.cmdBar.actionCompleteCase exists in AMN only, it is undefined in HealthCare
		CanComplete				: {attr :'CanComplete',				downto : 'CanComplete',				actionIndex : jsPAL.cmdBar.actionCompleteCase},
		CanEdit					: {attr :'CanEdit',					downto : 'CanEdit'},
		CanRequestAw			: {attr :'CanRequestAW',			downto : 'CanRequestAW',			actionIndex : jsPAL.cmdBar.actions.actionRequestAdditionalWork},
		CanSendToIC				: {attr :'CanSendToIC',				downto : 'CanSendToIC',				actionIndex : jsPAL.cmdBar.actions.actionSendConsultRequest},
		CanSendToOC				: {attr :'CanSendToOC',				downto : 'CanSendToOC',				actionIndex : jsPAL.cmdBar.actions.actionCopyForOutgoingConsult},
		CanSendToTB				: {attr :'CanSendToTB',				downto : 'CanSendToTB',				actionIndex : jsPAL.cmdBar.actionCopyForCareConference},
		CanDelete				: {attr :'CanDelete',				downto : 'CanDelete'},
		// RTS
		CanUpload				: {attr :'CanUpload',				downto : 'CanUpload',				actionIndex : jsPAL.cmdBar.actions.actionUpload},
		CanUploadAgain			: {attr :'CanUploadAgain',			downto : 'CanUploadAgain',			actionIndex : jsPAL.cmdBar.actions.actionUploadAgain}
	};
});
/**
 *	@namespace PAL
 *	Healthcare specific functionality that extends the default PAL object
 */
/**
 * The timing interval in seconds for the polling loop
 */
jsPAL.pollingTimer = 0;
/**
 * Used by caseassembly to prevent all tabs from being closed
 */
jsPAL.closingTab = false;
/**
 * Delimiter for the fields that make up the case tab text
 */
jsPAL.tabTextDelimiter = ' | ';
/**
* Prior Case tab text prefix string
*/
jsPAL.priorCaseTabTextPrefix = 'Prior Case';
/**
 * Array of sideNavModules (JavaScript code for each workflow)
 */
jsPAL.sideNavModules = [];
 /**
 * Timer used to reposition the command bar
 * 
 */
jsPAL.cmdBarRepositionTimer = 0;
/**
 * Elements returned in the GetXXX Methods when the current case has a consultation
 * The attributes are stored as attributes of the jQGrid <tr> elements
 *
 * attr:		The attribute name placed on the <tr> in the grid
 * downto:		The downtoXXX path that is returned from dataserver in the GetXXX methods
 */
jsPAL.shConsultationRequestColumns =
{
	ConsultRequestAssignedUserGroupId		: {attr :'ConsultRequestAssignedUserGroupId',	downto : 'DownToVwCaseConsultRequestCurrentByCaseId.AssignedUserGroupId'},
	ConsultRequestAssignedUserId			: {attr :'ConsultRequestAssignedUserId',		downto : 'DownToVwCaseConsultRequestCurrentByCaseId.AssignedUserId'},
	ConsultRequestAwnUserGroupId			: {attr :'ConsultRequestAwnUserGroupId',		downto : 'DownToVwCaseConsultRequestCurrentByCaseId.AwnUserGroupId'},
	ConsultRequestAwnUserId					: {attr :'ConsultRequestAwnUserId',				downto : 'DownToVwCaseConsultRequestCurrentByCaseId.AwnUserId'},
	ConsultRequestId						: {attr :'ConsultRequestId',					downto : 'DownToVwCaseConsultRequestCurrentByCaseId.ConsultRequestId'},
	ConsultRequestFromPalModuleId			: {attr :'ConsultRequestFromPalModuleId',		downto : 'DownToVwCaseConsultRequestCurrentByCaseId.FromPalModuleId'},
	ConsultRequestToPalModuleId				: {attr :'ConsultRequestToPalModuleId',			downto : 'DownToVwCaseConsultRequestCurrentByCaseId.ToPalModuleId'},
	ConsultRequestStateId					: {attr :'ConsultRequestStateId',				downto : 'DownToVwCaseConsultRequestCurrentByCaseId.StateId'}
};
/**
 * Called by sideNav Modules to register the module
 * @param module PALModule object
 */
jsPAL.registerSideNavModule = function(module)
{
	var found = false;
	for ( var i = 0; i < this.sideNavModules.length; i++)
	{
		if (this.sideNavModules[i].name === module.name)
		{
			found = true;
			break;
		}
	}
	if (found === false)
	{
		this.sideNavModules.push(module);
	}
};
/**
 * Init each side nav module by calling its init() function
 */
jsPAL.initSideNavModules = function()
{	
	for ( var i = 0; i < jsPAL.sideNavModules.length; i++)
	{
		var module = jsPAL.sideNavModules[i];
		if (typeof (module.init) === 'function')
		{
			module.init();
		}
	}
};
/**
 * Set the text displayed on the side bar
 * @param moduleName PALModule.Name
 * @param badgeText Usually numeric badge number
 */
jsPAL.setBadgeText = function(moduleName, badgeText)
{
	if (badgeText === '0' || badgeText === 0)
	{
		badgeText = '';
	}
	$('#' + moduleName + 'SideNav').badger(badgeText);
};
/**
 * Return a text string that is prefixed to case tab text
 * @returns The prefixed text
 */
jsPAL.getTabTextPrefix = function()
{
	return (null === jsPAL.tabTextPrefix ? '' : jsPAL.tabTextPrefix);
};
/**
 * Set a Prior Case text string that is prefixed to case tab text
 */
jsPAL.setPriorCaseTabTextPrefix = function()
{
	jsPAL.setTabTextPrefix(jsPAL.priorCaseTabTextPrefix);
};
/**
 * return true if tab is a prior case tab, specifically, if tab text begins with 'Prior Case | '
 */
jsPAL.isPriorCaseTab = function(tabDiv, tabIndex)
{
	var tabText = jsPAL.getTabTextByIndex(tabDiv, tabIndex);
	return jsPAL.isPriorCaseTabText(tabText);
};
/**
 * return true if tab text is for a prior case tab, specifically, if tab text begins with 'Prior Case | '
 */
jsPAL.isPriorCaseTabText = function(tabText)
{
	return tabText.indexOf(jsPAL.priorCaseTabTextPrefix + jsPAL.tabTextDelimiter) === 0;
};
/**
 * The delimiter character between items in the tab text
 * @param delimiter The delimiter character/string
 */
jsPAL.setTabTextDelimiter = function(delimiter)
{
	jsPAL.tabTextDelimiter = delimiter;
};
/**
 * build case tab text from up to 4 component strings
 * @param strings
 * @param caseIdText The case primary key (id) from the database
 */ 
jsPAL.buildCaseTabText = function(strings, caseIdText)
{
	var tabText = '';
	var maxLen = 24; // maximum length for each component string
	for (var i = 0; i < 4; i++)
	{
		if (undefined === strings[i])
		{
			strings[i] = '';
		}
	}
	// if there is a tab text prefix string specified, then set the prefix in
	// the tabtext
	var prefix = jsPAL.getTabTextPrefix(); 
	if (undefined !== prefix && null !== prefix)
	{
		tabText = prefix;
	}
	for (i = 0; i < 4; i++)
	{
		if (strings[i] !== '')
		{
			if (tabText.length > 0)
			{
				tabText += jsPAL.tabTextDelimiter;
			}
			tabText += this.limitLength(strings[i], maxLen);
		}
	}
	if (tabText === '')
	{
		if (undefined === caseIdText || -1 === caseIdText)
		{
			//defaultTabText is a superGlobal defined in cWorkflowBuilder
			tabText = defaultTabText;
		}
		else
		{
			tabText = 'Case ' + caseIdText;
		}
	}
	return tabText;
};
/**
 * Limit the length of a string
 * @param str The string
 * @param maxLen The maximum length of the string
 */
jsPAL.limitLength = function(str, maxLen)
{
	if (str.length > maxLen)
	{
		str = str.substr(0, maxLen / 2) + '...' + str.substr(str.length - maxLen / 2);
	}
	return str;
};
/**
 * AJAX polling function called periodically by the healthcare framework
 * Gets the badge updates and conferencing updates
 */
jsPAL.pollingLoop = function()
{
	var caseRowsVisible = jsPAL.getVisibleCaseRows();
	var specimenRowsVisible = jsPAL.getVisibleSpecimenRows();
	var slideRowsVisible = jsPAL.getVisibleSlideRows();

	Ajax(
	{
		type : "GET",
		url : "/PALModules/HealthCare/GetHealthCareAJAXData.php?UserId=" + SystemParms.UserId + "&caseIds=" + caseRowsVisible + "&specimenIds=" + specimenRowsVisible + "&slideIds=" + slideRowsVisible,
		success : function(msg)
		{
			var response = ParseJson(msg);
			if (response == null)
			{
				jsPAL.stopPollingLoop();
				return false;
			}
			try
			{
				// update the badge counts on the side nav bar
				if (undefined !== response.GetBadges)
				{
					jsPAL.updateBadges(response.GetBadges);  
				}

				//check for transfer progress updates
				if (undefined !== response.TransferProgressData)
				{
					jsPAL.updateTransferProgress(response.TransferProgressData);
				}
				// polling succeeded
				return true;
			}
			catch (err)
			{
				return false;
			}			
		 },
		 error : function(jqXHR, textStatus, errorThrown)
		 {
			 return false;
		 }
	 });
};

/**
 * Stop the periordic update of the healtcare data
 */
jsPAL.stopPollingLoop = function()
{
	if (this.pollingTimer !== 0)
	{
		clearInterval(this.pollingTimer);
	}
};
/**
 * Update the badge data. 
 * These are the badge counts on the left hand sidebar
 */
jsPAL.updateBadgeData = function()
{
	Ajax(
	{
		type : "GET",
		url : "/PALModules/HealthCare/GetBadges.php",
		success : function(msg)
		{
			// update the badge counts on the side nav bar
			var response = ParseJson(msg);
			if (response)
				jsPAL.updateBadges(response);
		},
		error : function(jqXHR, textStatus, errorThrown)
		{
		}
	});
};

/**
 * For a given entity type (case, specimen, slide), id and div selector, return the jQuery wrapped progress bar div
 */
jsPAL.getProgressBarDiv = function(entityName, id, divSelector)
{
    var tableSelector = 'table[tablename="' + entityName + '"] tr[id=' + id + ']';
    var progressBarSelector = 'div[columnname=' + divSelector + ']';
    return $(tableSelector).find(progressBarSelector);   
}

/**
 * Update the progress bar value and status
 * @param $progDiv The jQuery wrapped progress bar div
 * @param xfr_progress The transfer progress (0-100%)
 * @param xfr_status The status string for the entity (case, specimen, slide)
 */
jsPAL.updateProgress = function($progDiv, xfr_progress, xfr_status)
{
    // Note: if for some reason the progressbar has not been created yet, do nothing
    if ($progDiv.is(':ui-progressbar'))
    {                                 
        var transferProgressValue = parseInt(xfr_progress);
        
        // here, we read the status value and update the border and tooltip accordingly
        jsPAL.setProgressBarStatus($progDiv, xfr_status, transferProgressValue);                                
        
       // if the value is different, update it
        if ($progDiv.progressbar("value") != transferProgressValue)
        {    
            $progDiv.progressbar("value",transferProgressValue);                                       
        }
        else
            jsPAL.setProgressBarValueText($progDiv,transferProgressValue);
            
    } 
}

/**
 * Update the transfer progress on all of grids
 * @param transferProgressData The JSON data from GetHealthCareAJAXData.php
 */
jsPAL.updateTransferProgress = function(transferProgressData)
{
	try
	{		
		if (transferProgressData) //if there is no data then bail
		{
            for (var i = 0; i < transferProgressData.length; i++ )
            {
                var caseInfo = transferProgressData[i];
                if (caseInfo)
                {
                    $progDiv = jsPAL.getProgressBarDiv("Case", caseInfo.Id, "DownToVwCaseAggregatesByCaseId\\.TransferProgress");
                    if ($progDiv.length > 0)
                    {
                        jsPAL.updateProgress($progDiv, caseInfo.Progress, caseInfo.Status);                    
                        for (var j = 0; j < caseInfo.Specimens.length; j++ )
                        {
                            var specInfo = caseInfo.Specimens[j];
                            $progDiv = jsPAL.getProgressBarDiv("Specimen", specInfo.Id, "DownToVwSpecimenAggregatesBySpecimenId\\.TransferProgress");
                            if ($progDiv.length > 0)
                            {
                                jsPAL.updateProgress($progDiv, specInfo.Progress, specInfo.Status);
                                for (var k = 0; k < specInfo.Slides.length; k++ )
                                {                            
                                    var slideInfo = specInfo.Slides[k];
                                    $progDiv = jsPAL.getProgressBarDiv("Slide", slideInfo.Id, "DownToVwSlideAggregatesBySlideId\\.TransferProgress");
                                    jsPAL.updateProgress($progDiv, slideInfo.Progress, slideInfo.Status);                        
                                }
                            }
                        }
                    }
                }
            }

		}
	}
	catch (msg)
	{
        //swallow any messages in updating the transfer progress
	}
};

/*
 * Update the badge data. 
 * @param badgeData The json data from GetBadges.php
 */
jsPAL.updateBadges = function(badgeData)
{
	try
	{
		var refreshGrids = false;
		var getBadgeResult = badgeData.GetBadgesResult;
		if (undefined !== getBadgeResult.ASResult && (getBadgeResult.ASResult == '0'))
		{
			Badge = badgeData.Badges.Badge;
			// update the badgecount for each PALModule
			for ( var i = 0; i < Badge.length; i++)
			{
				var moduleName = Badge[i].PALModuleName;
				if (jsPAL.getPALModuleName() == moduleName)
				{
					// if badge count for the current workflow has changed, set a
					// flag
					// to refresh visible jqGrids for the workflow
					var currentCount = $('#' + moduleName + 'SideNav').find('#Badge').text();
					if ('' === currentCount)
					{
						currentCount = '0';
					}
					refreshGrids = (currentCount != Badge[i].Count);
				}
				jsPAL.setBadgeText(moduleName, Badge[i].Count);
			}
		}
		if (refreshGrids)
		{
			jsPAL.refreshJQGrids();
		}
	}
	catch (msg)
	{
	}
};

/**
 * Create a request for a consultation
 * Uses the currently logged in user as the requester
 * @param caseId The id from the case table
 */
jsPAL.createConsultationRequest = function(caseId)
{
	// request consultation for case
	if (undefined !== caseId && '' !== caseId)
	{
		jsPAL.displayNotification("Copying Case Data", 0);
		Ajax(
		{
			type : "POST",
			url : "/PALModules/HealthCare/CreateCaseConsultationRequest.php",
			data : "caseid=" + caseId,
			success : function(msg)
			{
				var response = ParseJson(msg);
				if (response == null)
					return;
				if (response.ASResult == '0')
				{
					jsPAL.displayNotification("Case Copied to Outgoing Collaboration Workflow");
					jsPAL.refreshJQGrids();
					jsPAL.updateBadgeData();
					jsPAL.cmdBar.clearCmdBar();
				}
				else
				{
					jsPAL.closeNotification();
					alert(CleanUpDSErrorMessage(response.ASMessage));
				}
			},
			error : function(jqXHR, textStatus, errorThrown)
			{
				jsPAL.closeNotification();
				alert("Error Copying Case to Outgoing Collaboration Workflow");
			}
		});
	}
};
/**
 * Create a request for a consultation review
 * Uses the currently logged in user as the requester
 * @param caseId The id from the case table
 */
jsPAL.createConsultationReview = function(caseId)
{
	// request consultation for case
	if (undefined !== caseId && '' !== caseId)
	{
		jsPAL.displayNotification("Copying Case Data", 0);
		Ajax(
		{
			type : "POST",
			url : "/PALModules/HealthCare/CreateCaseConsultationReview.php",
			data : "caseid=" + caseId,
			success : function(msg)
			{
				var response = ParseJson(msg);
				if (response == null)
					return;
				if (response.ASResult == '0')
				{
					jsPAL.displayNotification("Case Copied to Incoming Collaboration Workflow");
					jsPAL.refreshJQGrids();
					jsPAL.updateBadgeData();
				}
				else
				{
					jsPAL.closeNotification();
					alert(response.ASMessage);
				}
			},
			error : function(jqXHR, textStatus, errorThrown)
			{
				jsPAL.closeNotification();
				alert("Error Copying Case to Incoming Collaboration Workflow");
			}
		});
	}
};
/**
 * Complete a case
 * @param caseId The id from the case table
 */
jsPAL.completeCase = function(caseId)
{
	// mark case as completed
	if (undefined !== caseId && '' !== caseId)
	{
		// special check for ConsultationReview workflow (now called Incoming
		// Consult), inform user that Annotations and Slide Memos
		// are not sent back to the consultation requestor
		if (jsPAL.getPALModuleName() === 'ConsultationReview')
		{
			jsPAL.doCompleteICCase(caseId);
		}
		else
		{
			jsPAL.doCompleteCase(caseId);
		}
	}
};
/**
 * Complete a case from SecondSlide [the only currently defined external source]
 * @param caseId The Id of the caseId.
 */
jsPAL.completeExternalCase = function(caseId)
{
	this.displayNotification('Completing External Case Collaboration');
	var operationsEvent = 'PALCompleteExternalCaseReview';
	$(document).bind(operationsEvent, function(event, eventData)
	{
		$(document).unbind(operationsEvent);
		jsPAL.displayNotification("External Case Collaboration Marked as Complete");
		// hide the consultation section marked as complete; don't close in case background ops require data exists on page
		jsPAL.hideConsultationCase(caseId);
		// Note, following commented out code is from FB case 16487
		// Perhaps should close the case tab if last consult?
		//var mainCaseId = jsPAL.getCurrentCase();
		//jsPAL.closeCaseTab($('#MainTabs'), mainCaseId);

		// build the case tab row id, e.g. #ConsultatationRequestTabs
		var caseTabRowId = '#' + jsPAL.getPALModuleName() + 'Tabs';
		// clear ModifiedTab class for the selected tab in the case tab row
		$(caseTabRowId + ' [aria-selected="true"] a').removeClass("ModifiedTab");
		// if no other tabs in the case tab row are modified, clear the ModifiedTab class in the MainTabs row
		if (0 === $(caseTabRowId).find('.ModifiedTab').length)
			$('#MainTabs [aria-selected="true"] a').removeClass("ModifiedTab");
		// refresh the case grid
		jsPAL.refreshJQGrids();
	});
	SetupNodes('/PALModules/HealthCare/CompleteExternalCaseReview.php', 'PalOperationsNode');
	this.PALOperationsNode.Parms = 'CaseId=' + caseId;
	this.PALOperationsNode.OperationsEvent = operationsEvent;
	this.PALOperationsNode.TableName = 'Case';
	this.PALOperationsNode.Ids = caseId;
	this.runOperationsQueue();
	return true;
};
jsPAL.hideConsultationCase = function(caseId)
{
	$('div.ListTableDiv li.ViewDisplay textarea[primarykey="' + caseId + '"]').closest('.ListTableDiv').hide();
}
/**
 * Complete a case
 * @param caseId The id from the case table
 */
jsPAL.doCompleteCase = function(caseId)
{
	this.displayNotification('Completing Case');
	var operationsEvent = 'PALCompleteCase';
	$(document).bind(operationsEvent, function(event, eventData)
	{
		$(document).unbind(operationsEvent);
		jsPAL.displayNotification("Case Marked as Completed");
		// close the case tab
		jsPAL.closeCaseTab($('#MainTabs'), caseId);
	});
	SetupNodes('/PALModules/HealthCare/CompleteCase.php', 'PalOperationsNode');
	this.PALOperationsNode.Parms = 'CaseId=' + caseId;
	this.PALOperationsNode.OperationsEvent = operationsEvent;
	this.PALOperationsNode.TableName = 'Case';
	this.PALOperationsNode.Ids = caseId;
	this.runOperationsQueue();
	return true;
};
/**
 * complete an IncomingConsult case
 * inform the user that only results are sent back, not annotations or memos.
 * allow the user to either choose to complete the case, or to open the case and
 * enter some results
 * @param caseId The id from the case table
 */
jsPAL.doCompleteICCase = function(caseId)
{
	createModalConfirm('Only <b><i>Collaboration Results</i></b> are sent back to the Collaboration Requester.<br/>Any changes you may have made to Annotations and/or Slide Memos are not sent back to the Requester.<br/><br/>Would you still like to complete the Case?', function()
	{
		// this function is executed when the user clicks the Yes button
		jsPAL.doCompleteCase(caseId);
	}, 'Yes', function()
	{
		// this function is executed when the user clicks the No button
		// switch to the results tab for the case
		jsPAL.selectResultsTab(caseId, '#ConsultationReviewTabs');
	}, 'No', 'Complete the Case');
};
/**
 * Complete a case review
 * @param caseId The id from the case table
 */
jsPAL.completeCaseReview = function(caseId)
{
	// mark Consultation Review as completed
	if (undefined !== caseId && '' !== caseId)
	{
		Ajax(
		{
			type : "POST",
			url : "/PALModules/HealthCare/CompleteCaseReview.php",
			data : "caseid=" + caseId,
			success : function(msg)
			{
				var response = ParseJson(msg);
				if (response == null)
					return;
				if (response.ASResult == '0')
				{
					jsPAL.displayNotification("Case Review Completed");
					jsPAL.refreshJQGrids();
					jsPAL.updateBadgeData();
				}
				else
				{
					alert(response.ASMessage);
				}
			},
			error : function(jqXHR, textStatus, errorThrown)
			{
				alert("Error Marking Case Review as Completed");
			}
		});
	}
};
/**
 * Use the operation queue to save the result text and set the complete case event
 * Called from pressing the save and complete button
 */
jsPAL.saveAndCompleteCase = function()
{
	var val = $('textarea[downtosyntax="DownToCaseReviewResultByCaseId.ResultText"]').filter(':visible').val() 
	if (undefined === val || '' === val)
	{
		createModalConfirm('You have not entered any results for this case.<br/>Do you want to complete the case without entering results?',
			function()
			{
				// "Yes" function
				jsPAL.saveCaseAndWaitForComplete();
			}, 'Yes',
			function()
			{
				// "No" function
			}, 'No',
			'Complete Case Without Entering Results');
			
	}
	else
	{
		jsPAL.saveCaseAndWaitForComplete();
	}
	return false;
};
/**
 * Use the operation queue to save the result text and set the complete case event
 */
jsPAL.saveCaseAndWaitForComplete = function()
{
    // prevent additional button clicks during this. there is a timing issue where the Add Report
    // button can be clicked after the case is complted, which results in an error
    $('input[type="button"]:not(".esigButton")').attr('disabled', 'disabled').addClass('ui-state-disabled');
	SaveAll();
	jsPAL.awaitingSaveAllForCompleteCaseEvent = true;
	NeedCheck=true;
};
/**
 * Locates the header columns from grid.
 */
jsPAL.getCaseObj = function(row)
{
	var colModel = $(".ui-jqgrid-btable").jqGrid('getGridParam', 'colModel');
	return jsPAL.parseRow(colModel, row.find('td'));
};
/**
 * Returns the case id for the case that is currently being viewed
 * @returns The id from the case table
 */
jsPAL.getCurrentCase = function()
{	
	var caseId = '';
	var mainTabs = $('#MainTabs');
	var tabIndex = jsPAL.getSelectedTabIndex(mainTabs);
	var div = jsPAL.getTabPanelDiv(mainTabs, tabIndex);
	if (tabIndex == 0)
	{
		caseId = div.find('.tablegrid').filter(':visible').jqGrid('getGridParam', 'selrow');
	}
	else
	{
		// all other tabs contain case views, get the div for the tab
		// and return the case id from that div
		if (div.attr('tablename') == 'case')
		{
			caseId = div.attr('primarykey');
		}
	}
	return caseId;
};
/**
* Returns value of critical column for a case from the grid on the main tab.
* Assumes that the case row is visible in the main tab's grid
* 
* @returns value
*/
jsPAL.getCaseCriticalColumnFromGrid = function(caseId, columnName)
{
	var columnValue;
	var row = jsPAL.getCaseGridRow(caseId);
	if (row.length > 0)
		columnValue = row.attr(columnName);
	return columnValue;
}
/**
 * Dynamically change the case tab text when the user is changing patient information
 * @param caseId The id from the case table
 * @parem tabDiv The tab div, e.g. $('#MainTabs')
 */
jsPAL.updateCaseTabText = function(caseId, tabDiv)
{
	// find the div for the tab
	var tabindex = jsPAL.getSelectedTabIndex(tabDiv);
	var caseDiv = jsPAL.getTabPanelDiv(tabDiv, tabindex);
	// get the defaultCaptionText values, which are the individual component text values
	// that were concatenated to make the initial captionText when the tab was loaded.
	var defaultCaptionText = jsPAL.getSelectedTab(tabDiv).data('DefaultCaptionText');
	if (undefined === defaultCaptionText)
		defaultCaptionText = {};
	if (caseDiv.attr('tablename') === 'case')
	{
		var strings = new Array('', '', '', '');
		var numFields = Math.min(SystemParms.CaseCaptionFields.length, 4);
		for (var i = 0; i < numFields; i++)
		{
			var tableName = SystemParms.CaseCaptionFields[i].tablename;
			var columnName = SystemParms.CaseCaptionFields[i].fieldcolumn;
			var primaryKey = '[primarykey=' + caseId + ']';
			var selector;
			if (tableName === 'Case' && columnName === 'PatientGender')
			{
				// PatientGender is a typically a select, not an input
				selector = 'select[tablename=Case][columnname=PatientGender]' + primaryKey;
				var sel = caseDiv.find(selector);
				if (sel.length > 0)
					strings[i] = sel.find(':selected').val();
				else
				{
					// not found as a select, try a normal input
					selector = ':input[tablename=' + tableName + '][columnname=' + columnName + ']' + primaryKey;
					var input = caseDiv.find(selector);
					if (input.length > 0)
					{
						strings[i] = input.val();
					}
					else
					{
						if (undefined !== defaultCaptionText[columnName])
							strings[i] = defaultCaptionText[columnName];
					}
				}
				// we only want the first character - M or F
				strings[i] = strings[i].substr(0, 1);
			}
			else
			{
				selector = ':input[tablename=' + tableName + '][columnname=' + columnName + ']' + primaryKey;
				var input = caseDiv.find(selector);
				if (input.length === 0)
				{
					// didn't find an input for the table/column
					// special check for PatientFullName. This field is not
					// displayed in case assembly
					// so construct it from the last name and first name, which
					// are displayed in case assembly
					if (tableName === 'Case' && columnName === 'PatientFullName')
					{
						// synthesize PatientFullName from PatientName and PatientFirstName
						strings[i] = '';
						var patientName = caseDiv.find(':input[tablename=Case][columnname=PatientName]' + primaryKey);
						var patientFirstName = caseDiv.find(':input[tablename=Case][columnname=PatientFirstName]' + primaryKey);
						if (patientName.length > 0)
						{
							strings[i] = patientName.val();
						}
						if (patientFirstName.length > 0)
						{
							if (strings[i].length > 0)
							{
								strings[i] += ', ';
							}
							strings[i] += patientFirstName.val();
						}
					}
					else
					{
						// use default text
						if (undefined !== defaultCaptionText[columnName])
							strings[i] = defaultCaptionText[columnName];
					}
				}
				else
				{
					// found the input, use the input's val()
					strings[i] = input.val();
				}
			}
		}
		// build tab text
		tabText = jsPAL.buildCaseTabText(strings, caseId);
		jsPAL.setSelectedTabText(tabDiv, tabText);
	}
};
/**
 * Dynamically update the case assembly's patient age when the user is chaning dob
 */
jsPAL.updatePatientAge = function()
{
	// find the div for the tab
	var tabindex = jsPAL.getSelectedTabIndex($('#MainTabs'));
	var caseDiv = jsPAL.getTabPanelDiv($('#MainTabs'), tabindex);
	var patientDOBText = caseDiv.find('input[columnname=PatientDOB][tablename=Case]').val();
	var patientAgeText = jsPAL.computeAge(patientDOBText);
	var ageInput = caseDiv.find('input[columnname=PatientAge][tablename=Case]');
	if (ageInput.val() != patientAgeText)
	{
		ageInput.val(patientAgeText).addClass('Modified');
	}
};
/**
 * Open a case in spectrum plus.  
 * This occurs when the user clicks the spectrum plus logo in SHC
 * iDevices cannot go back to Spectrum Plus
 */
jsPAL.openCaseInSpectrumPlus = function()
{
	/***
	if ((true === SystemParms.isiPad) || (true === SystemParms.isiPhone))
	{
		alert('Cannot Open case in basic eSlideMgr from iDevice');
	}
	else
	*****/
	{
		var caseId = this.getCurrentCase();
		if (undefined !== caseId && '' !== caseId && ('undefined' !== typeof caseId) && (null != caseId))
		{
			// the try/catches prevent 'Unspecified Error' in IE when the 'Stay on Current Page' is selected
			// from the onbeforeunload event
			try
			{
				window.location.assign('/EditRecord.php?HealthCareReferer=1&TableName=Case&Ids[]=' + caseId);
			}
			catch(ex)
			{
			}
		}
		else
		{
			// no case is opened, switch to /welcome.php
			try
			{
				window.location.assign('/welcome.php?HealthCareReferer=1;');
			}
			catch(ex)
			{
			}
		}
	}
};
/**
 * Create a new tab That Loads The Spectrum Plus Advanced Search
 * @param divId If set, the HTML id of container to put the search criteria into,  otherwise creates a new Top Level tab
 * @param searchId If set, the primary key from SavedSearch table [Used when pressing the Load Button]
 * @param results flag if true will load results from Records_List.php into the Search tab, used in top nav search items drop down list
 */
jsPAL.displayAdvancedSearchCriteria = function(divId, searchId, results)
{
	if (typeof(closeNewCaseTab) === 'function')
	{
		closeNewCaseTab();
	}		
	jsPAL.displayNotification('Loading Search Parameters... ');
	var divToLoad;
	var searchErrorMessage = "There was an error creating the Search";
	var loadstr = '';
	if (!divId)
	{
		var mainTabs = $('#MainTabs');
		jsPAL.closeTabByText(mainTabs, 'Search');
		var tabIndexCount = mainTabs.children('ul').children('li').size();
		var id = jsPAL.addNewTab(mainTabs, 'Search', tabIndexCount, false, true, true);
		jsPAL.getTabsForDiv(mainTabs).eq(tabIndexCount).addClass('searchtab');
		divToLoad = $('#' + id);                                                             
		// use the id of the newly created tab as the key into the opened tabs
		AlreadyOpenedCases[id] =
		{
			isSearchTab : false,
			caseId : -99,
			childTabsDivId : id,
			mainTabRowIndex : tabIndexCount,
			mainTabRowId : 'MainTabs'
		};
		$(divToLoad).click(function()
		{
			HideSearchParamSelection();
		});
	}
	else
	{
		divToLoad = $('#' + divId);
		// remove the existing search
		$(divToLoad).empty();
	}
	var moduleName = jsPAL.getPALModuleName();
	if (moduleName === 'HealthcareAdmin')
		moduleName = 'AllRecords';
	if (results == true)
	{	
		loadstr = '/Records_List.php?DisplayRecordsOnly=true&DataServerClient=3&DataServerMethod=Get' + moduleName + 'Records&MethodSoapElements[]=' + (searchId ? '&SearchId=' + searchId : '');
	}
	else
	{
		loadstr = '/SearchCriteria.php?DisplayRecordsOnly=true&DataServerClient=3&DataServerMethod=Get' + moduleName + 'Records&MethodSoapElements[]=&ContainingSearchDivId=' + $(divToLoad).attr('Id') + (searchId ? '&SearchId=' + searchId : '');	
	}
	$(divToLoad).load(loadstr, function(response, status, xhr)
	{
		if (status === "error")
		{
			alert(searchErrorMessage);
		}
		else
		{
			jsPAL.closeNotification();
			// __TMP__ Take the TMA link out for the USCAP demo [this
			// may not be completely correct]
			$("#SearchForTableName option[value='TMA']").remove();
		}
		if (results == true)
		{
			InitializeNodes();
			jsPAL.renameAdvanceSearchResults(divToLoad);
		}
	});
};
/**
 * Receives all of the advanced search results from Records_List.php and ColumnSort() and changes all of 
 * The Spectrum Plus Links to Spectrum HealthCare Links
 * Also disables all of the image links in the below search results table 
 * The only items that can currently be opened are ones who are associated with a Case
 * This restricts the links to Case,Specimen,Slide,Image
 */
jsPAL.renameAdvanceSearchResults = function(searchDiv)
{
	var caseIdArray = [];
	var slideIdArray = [];
	var specimenIdArray = [];

	$(searchDiv).find("a[href*='EditRecord\.php']").each(function()
	{
		var searchHref = decodeURI($(this).attr('href'));
		var editRecordRegEx = /^\/EditRecord.php\?TableName\=(.*)\&Ids\[\]\=(.*)/;
		var editRecordMatches = editRecordRegEx.exec(searchHref);

		if (3 === editRecordMatches.length)
		{
			var tableName = editRecordMatches[1].toLowerCase();
			var primaryKey = editRecordMatches[2];

			if ('case' === tableName.toLowerCase())
			{
				if (-1 === $.inArray(primaryKey, specimenIdArray))
				{
					caseIdArray.push(primaryKey);
				}
			}
			else if ('specimen' === tableName)
			{
				if (-1 === $.inArray(primaryKey, specimenIdArray))
				{
					specimenIdArray.push(primaryKey);
				}
			}
			else if ('slide' === tableName)
			{
				if (-1 === $.inArray(primaryKey, slideIdArray))
				{
					slideIdArray.push(primaryKey);
				}
			}
		}
	});
	// remove the hover popouts in the SHC advanced search results
	$(searchDiv).find("span.hoverpopup").remove();
	// remove the bulk task column from the SHC advanced search results
	var bulkColumnIndex = $(searchDiv).find('table.ListTable th input[name=BulkSelectBox]:first').parent().closest('th').index();
	if (bulkColumnIndex >= 0)
	{
		$(searchDiv).find('table.ListTable th input[name=BulkSelectBox]:first').parents("table").find("tr").each(function()
		{
			$(this).find("td:eq(" + bulkColumnIndex + ")").remove();
			$(this).find("th:eq(" + bulkColumnIndex + ")").remove();
		});
	}
	// Remove the BulkTask Links
	$(searchDiv).find('table.ListHeader td.BulkTasks').remove();

	// SELECT Distinct C.Id From [Case] AS C
	// INNER JOIN Specimen AS [Sp] ON Sp.ParentId = C.Id AND Sp.ParentTable =
	// 'Case'
	// INNER JOIN Slide AS [S] ON S.ParentId = Sp.Id AND S.ParentTable =
	// 'Specimen'
	// WHERE C.ID IN ()
	// OR Sp.Id IN (138)
	// OR S.Id IN (10,20)
	var caseFilter = '';
	if (caseIdArray.length > 0)
	{
		caseFilter = '    <FilterBy Column="Id" FilterOperator="IN" FilterValue="' + caseIdArray.join(',') + '" Table="Case"/>';
	}
	var specimenFilter = '';
	if (specimenIdArray.length > 0)
	{
		specimenFilter = '    <FilterBy Column="DownToSpecimenByParentId.Id" FilterOperator="IN" FilterValue="' + specimenIdArray.join(',') + '" Table="Case"/>';
	}
	var slideFilter = '';
	if (slideIdArray.length > 0)
	{
		slideFilter = '    <FilterBy Column="DownToSpecimenByParentId.DownToSlideByParentId.Id" FilterOperator="IN" FilterValue="' + slideIdArray.join(',') + '"  Table="Case"/>';
	}

	var advSearchFilter = encodeURIComponent('<Parenthesis Connector="Or">' + caseFilter + specimenFilter + slideFilter + ' </Parenthesis>');

	// only format the search results if there is something to update
	if ((slideIdArray.length > 0) || (specimenIdArray.length > 0) || (caseIdArray.length > 0))
	{
		$(document).unbind('RenameAdvanceSearchResults');
		$(document).bind('RenameAdvanceSearchResults', function(event, searchDiv)
		{
			jsPAL.renameAdvanceSearchResults(searchDiv);
            if ('function' === typeof thePaginator.paginator)
            {
                if ('undefined' == typeof StartMulti )
                {
                    $.getScript('/js/MultiColumnSort.js?$SpectrumVersion');
                }
                $('#ButtonAddNew').remove();
                thePaginator.paginator(true);
            }
		});

		Ajax(
		{
			type : "POST",
			url : "/AJAXDataBaseRead.php",
			data : "Method=GetFilteredRecordListWithFilterArray" + "&TableName=Case" + "&Columns=Id%2CDownToSpecimenByParentId.Id%2CDownToSpecimenByParentId.DownToSlideByParentId.Id" + "&Distinct=true" + "&SortField=Id" + "&SortOrder=Ascending" + "&FilterArray=" + advSearchFilter,
			success : function(data)
			{
				// process all of the case ids in the response message (data)
				// each <a href> needs to be walked and updated with a new open
				// case link
				$(searchDiv).find("a[href*='EditRecord\.php']").each(function()
				{
					var searchHref = decodeURI($(this).attr('href'));
					var editRecordRegEx = /^\/EditRecord.php\?TableName\=(.*)\&Ids\[\]\=(.*)/;
					var editRecordMatches = editRecordRegEx.exec(searchHref);
					// make sure to clear out all of the links
					$(this).attr('SearchLinkUpdated', 'false');

					if (3 === editRecordMatches.length)
					{
						var tableName = editRecordMatches[1].toLowerCase();
						var primaryKey = editRecordMatches[2];
						var searchDownTo = '';

						if ('case' === tableName.toLowerCase())
						{
							searchDownTo = 'Id';
						}
						else if ('specimen' === tableName)
						{
							searchDownTo = 'DownToSpecimenByParentId.Id';
						}
						else if ('slide' === tableName)
						{
							searchDownTo = 'DownToSpecimenByParentId.DownToSlideByParentId.Id';
						}

						var caseId = '';
						if (searchDownTo)
						{
							for ( var i = 0; i < data.length; i++)
							{
								var gfrlRow = data[i];
								for ( var gfrlResult in gfrlRow)
								{
									if (gfrlResult === searchDownTo)
									{
										var gfrlResultValue = gfrlRow[gfrlResult];
										if (gfrlResultValue === primaryKey)
										{
											caseId = gfrlRow['Id'];
											break;
										}
									}
								}
								if (caseId)
								{
									$(this).attr('href', '#');
									$(this).attr('SearchLinkUpdated', 'true');
									// bind the click handler for the search
									// result to open the case in the tabs
									$(this).click(function()
									{
										var isCaseAlreadyOpen = false;
										// walk the AlreadyOpenedCases and check
										// if the case is already open
										// when found the
										// AlreadyOpenedCases[].mainTabRowIndex
										// can be used to remove the tab
										if (AlreadyOpenedCases)
										{
											for ( var key in AlreadyOpenedCases)
											{
												var caseTab = AlreadyOpenedCases[key];
												var openendCaseId = caseTab['caseId'];
												var openendCaseTabIndex = caseTab['mainTabRowIndex'];

												if (openendCaseId === caseId)
												{
													jsPAL.selectTab($('#MainTabs'), openendCaseTabIndex);
													isCaseAlreadyOpen = true;
													break;
												}
											}
										}
										// the the case is not already opened
										// the use the current workflows load
										// method
										if (!isCaseAlreadyOpen)
										{											
											if ('AllRecords' === jsPAL.getPALModuleName())
											{
												loadAllRecordsTabsUsingCaseId(caseId, '3', 'GetAllRecordsRecords');
											}
											else if ('CaseAssembly' === jsPAL.getPALModuleName())
											{
												loadCaseAssemblyTabsUsingCaseId(caseId, '3', 'GetCaseAssemblyRecords');
											}
											else if ('DigitalReview' === jsPAL.getPALModuleName())
											{
												loadDigitalReviewTabsUsingCaseId(caseId, '3', 'GetDigitalReviewRecords');
											}
											else if ('IntraOperative' === jsPAL.getPALModuleName())
											{
												loadIntraOperativeTabsUsingCaseId(caseId, '3', 'GetIntraOperativeRecords');
											}
											else if ('ConsultationRequest' === jsPAL.getPALModuleName())
											{
												loadConsultationRequestTabsUsingCaseId(caseId, '3', 'GetConsultationRequestRecords');
											}
											else if ('ConsultationReview' === jsPAL.getPALModuleName())
											{
												loadConsultationReviewTabsUsingCaseId(caseId, '3', 'GetConsultationReviewRecords');
											}
										}
										return false;
									});
									break;
								}
							}
						}
					}
				});
				// some yet unknown table/page generated a link that is not in
				// the standard set
				// prompt the user if they would like to be redirected to
				// spectrum plus to view the search result
				$(searchDiv).find("a[SearchLinkUpdated=false]").each(function()
				{
					$(this).attr('SearchLinkUpdated', 'true');
					$(this).click(function()
					{
						var redirectConfirm = confirm("Load Search Result in Spectrum+ ?");
						if (redirectConfirm)
						{
							// redirect to the search result
							window.location = $(this).attr('href').toString();
						}
						// dont follow link
						return false;
					});
				});
				// do not do anything with images in the search results
				// unbind all of the image onclick handlers
				$(searchDiv).find("img.ImageDelay").each(function()
				{
					// remove any of the bound click handlers to open in
					// webscope or imagescope
					$(this).attr('onclick', '').unbind('click');
				});
				// some of the cList table also use anchors with a onclick
				// function to display images
				// These include the report, maco, and analysis images
				// they are wrapper with a thumnailDiv and their anchor tags
				// should not be turned into spans
				$(searchDiv).find("td:not(.BulkTasks,.Paginator) a").each(function()
				{
					var onClickFunc = $(this).attr("onclick");
					var parentThumnailDiv = $(this).parent('div.thumbnailDiv');
					if (0 == parentThumnailDiv.length)
					{
						if (onClickFunc)
						{
							if ((-1 !== onClickFunc.indexOf('viewImage')) || (-1 !== onClickFunc.indexOf('SingleViewWithImageScopeOrBrowser')))
							{
								$(this).attr('href', '#');
								// remove any of the bound click handlers to
								// open in webscope or imagescope
								$(this).attr('onclick', '').unbind('onclick');
								// turn the anchor into a readonly span
								$(this).replaceWith('<span>' + $(this).text() + '</span>');
							}
						}
					}
					else
					{
						// prevent all anchors from redirecting and remove all
						// of the onclick handlers
						// bound beneath the thumnail div
						$(this).attr('href', '#');
						$(this).attr('onclick', '').unbind('onclick');
						$(parentThumnailDiv).find("img").each(function()
						{
							$(this).attr('click', '').unbind('click');
						});
					}
				});
			},
			error : function(jqXHR, textStatus, errorThrown)
			{
				alert('Error Searching For Item');
			}
		});
	}
};

/**
 * Place the Spectrum Plus Advanced Search Results into the div specified by divId
 * @param divId The div to place the result into
 */
jsPAL.ajaxAdvancedSearchResultsToDiv = function(divId)
{
	var searchErrorMessage = "There was an error executing the search ";
	var searchDiv = $('#' + divId);
	if (searchDiv.length > 0)
	{
		var searchParms = $("#SearchForm").serialize();
		$(searchDiv).empty();
		jsPAL.displayNotification('Searching...');
		// send SetEnableJavascriptCListFlag = true parameter to enable javascript cList() for the paginator to work 
		$(searchDiv).load('/Records_List.php?DisplayRecordsOnly=true&SetEnableJavascriptCListFlag=true&' + searchParms, function(response, status, xhr)
		{
			if (status === "error")
			{
				jsPAL.closeNotification();
				alert(searchErrorMessage);
			}
			else
			{
				// Record_List.php Created the cList object but it needs to be
				// registered
				InitializeNodes();
				jsPAL.closeNotification();
				// Disable the List Header (including Column Navigation) in Network
				$(searchDiv).find('table.ListHeader').remove();
			}
			jsPAL.renameAdvanceSearchResults(searchDiv);
		});
	}
	else
	{
		alert(searchErrorMessage);
	}
	return false;
};
/**
 * Spectrum Plus Advanced Search Results Delete button press placing the result into the div specified by divId
 * @param divId The div to place the delete response into
 * @param searchName SQL SavedSearch.Name
 */
jsPAL.ajaxAdvancedSearchDelete = function(divId, searchName)
{
	// trim whitespace and see if string is empty
	if (searchName.replace(/^\s+|\s+$/g, '').length == 0)
	{
		alert("You must specify the search name to delete");
		return false;
	}
	else
	{
		// non-empty string. Now confirm delete.
		if (!confirm("Are you sure you want to delete the search '" + searchName + "'"))
		{
			return false;
		}
	}
	var searchErrorMessage = "There was an error deleting the search ";
	var searchDiv = $('#' + divId);
	if (searchDiv.length > 0)
	{
		jsPAL.displayNotification('Deleting Search ' + searchName + ' ...');
		Ajax(
		{
			type : "POST",
			url : "/DeleteSearch.php?DisplayRecordsOnly=true&ContainingSearchDivId=" + divId +"&SearchName="+ searchName,
			data : $("#SearchForm").serialize(),
			success : function(msg)
			{
				jsPAL.closeNotification();
				$(searchDiv).empty();
				$(searchDiv).append(msg);
				ReloadFTList();
			},
			error : function(msg)
			{
				jsPAL.closeNotification();
				alert(searchErrorMessage);
			}
		});
	}
	else
	{
		alert(searchErrorMessage);
	}

	 return false;
 };
/**
 * Add SHC attributes to a html table row element from the GetXXX method
 *@param tableRow A html tr element
 *@param data The json data
 */
jsPAL.addShcTableRowAttributes = function(tableRow, data)
{
	for (var workflowKey in jsPAL.workflowSharedColumns)
	{
		var workflowColumn = jsPAL.workflowSharedColumns[workflowKey];
		$(tableRow).attr(workflowColumn.attr.toString(), data[workflowColumn.downto]);
	}
	for (var shRecordKey in jsPAL.shRecordStateColumns)
	{
		var recordStateColumn = jsPAL.shRecordStateColumns[shRecordKey];
		$(tableRow).attr(recordStateColumn.attr.toString(), data['SHRecordState'][recordStateColumn.downto]);
	}
};
/**
 * Add an already opened set of tabs with a given case to the global cache of case records
 * @param jqueryGridRow The currently selected jQrid row
 * @param caseId The case id
 * @param tabsDivId The div that is called with .tabs()
 * @param tabIndexCount The index into the tabs array
 * @param mainTabRowId The div of the top most level of tabs
 * @param isLocked True/False if the tab is shown locked
 */
jsPAL.addAlreadyOpenedCase = function(jqueryGridRow, caseId, tabsDivId, tabIndexCount,mainTabRowId, isLocked)
{
	AlreadyOpenedCases[caseId] = { isSearchTab     : false,
								   caseId          : caseId,
								   childTabsDivId  : tabsDivId,
								   mainTabRowIndex : tabIndexCount,
								   mainTabRowId    : mainTabRowId,
								   // unviewed attribute
								   unviewed			: jqueryGridRow.attr('unviewed'),
								   //tab construction lock state
								   isLocked : isLocked
								 };
	//add of the the 'access flags' type columns to the grid row
	for (var workflowKey in jsPAL.workflowSharedColumns)
	{
		var workflowColumn = jsPAL.workflowSharedColumns[workflowKey];
		var attr = jqueryGridRow.attr(workflowColumn.attr.toString());
		if (undefined == attr)
			attr = jqueryGridRow.attr(workflowColumn.downto.toString())
		if (undefined !== attr)
			AlreadyOpenedCases[caseId][workflowColumn.attr.toString()] = attr;
	}
	//add of the the 'canXXX' type actions columns to the grid row
	for (var shRecordKey in jsPAL.shRecordStateColumns)
	{
		var recordStateColumn = jsPAL.shRecordStateColumns[shRecordKey];
		var attr = jqueryGridRow.attr(recordStateColumn.attr.toString());
		if (undefined == attr)
			attr = jqueryGridRow.attr(recordStateColumn.downto.toString());
		if (undefined !== attr)
			AlreadyOpenedCases[caseId][recordStateColumn.attr.toString()] = attr;
	}
	//set the the access flag unlocking for the given row
	AlreadyOpenedCases[caseId]['accessflagsUnlockPermitted'] = (jqueryGridRow.attr('accessflags') ? ('full' === jqueryGridRow.attr('accessflags').toString().toLowerCase()) : false);
};
/*
Reloads the contents of the Saved Searches box on the nav site
call this after saving or deleting the search items
*/
function ReloadFTList ()		
{  
	$("#dropdown_box").empty();
	Ajax(
	{
		type: "POST",
		url: "/PALModules/HealthCare/GetSavedSearchList.php",
		data: "Status=3",
		success: function(thisdata)
		{     
			$("#dropdown_box").append(thisdata);
			SearchHover();
		},
		error: function(jqXHR, textStatus, errorThrown)
		{
			//// do nothing
		}
	});

}

/**
 * Handle Spectrum Plus Advanced Search Results delete button press placing the result into the div specified by divId
 * @param divId The div to place the delete response into
 * @param searchName SQL SavedSearch.Name
 */
jsPAL.ajaxAdvancedSearchSave = function(divId, searchName)
{
	// trim whitespace and see if string is empty
	if (searchName.replace(/^\s+|\s+$/g, '').length == 0)
	{
		alert("You must specify a name for the search");
		return false;
	}
	else
	{
		// non-empty string. Confirm if overwriting existing search
		// The DoesSavedSearchExist will exist in the document written from the
		// SearchCritera.PHP
		if (DoesSavedSearchExist(document.SearchForm.SearchName.value))
		{
			if (!confirm(document.SearchForm.SearchName.value + " already exists.  Are you sure you want to overwrite it?"))
			{
				return false;
			}
		}
	}
	var searchErrorMessage = "There was an error saving the search ";
	var searchDiv = $('#' + divId);
	if (searchDiv.length > 0)
	{
		jsPAL.displayNotification('Saving Search ' + searchName + ' ...');
		Ajax(
		{
			type : "POST",
			url : "/SaveSearch.php?DisplayRecordsOnly=true&ContainingSearchDivId=" + divId,
			data : $("#SearchForm").serialize(),
			success : function(msg)
			{
				jsPAL.closeNotification();
				$(searchDiv).empty();
				$(searchDiv).append(msg);
				ReloadFTList();
			},
			error : function(msg)
			{
				jsPAL.closeNotification();
				alert(searchErrorMessage);
			}
		});
	}
	else
	{
		alert(searchErrorMessage);
	}
	return false;
};
/**
 * Assign a case to a user and open that case in the tabs
 * @param link 
 * @param buildTabsFunction The javascript function for creating the tabs generated by cWorkflowBuilder
 */
jsPAL.assignCaseAndOpen = function(link, buildTabsFunction)
{
	var tr = $(link).closest('tr');
	var id = tr.attr('id');
	jsPAL.cmdBar.putCaseId(id);
	var grid = tr.closest('.ui-jqgrid-btable');
	grid.setSelection(id, true);
	var assignedGroup = $(link).closest('tr').attr('assignedusergroupid');
	if (undefined !== assignedGroup && assignedGroup !== '')
	{
		if (jsPAL.getPALModuleName() === jsPAL.palModuleNames.DigitalReview)
		{
			// in digital review, prompt the user whether to assign the case or not
			switch(SystemParms.CaseReviewAssignOption)
			{
				case 'assign':
					jsPAL.cmdBar.caseId = id;
					jsPAL.cmdBar.doAssignToMe(true);
					break;
				case 'readonly':
					buildTabsFunction(link);
					break;
				case 'prompt':
				default:
					createModalConfirm("This Case is not assigned to you.<br/>Would you like to become the reviewing Pathologist for the case?", function()
					{
						// this function is executed if the user clicks the Yes button
						jsPAL.cmdBar.doAssignToMe(true);
					}, "Yes, Review Case", function()
					{
						// this function is executed if the user clicks the No button,
						// don't assign the case to me, and open the case
						if (typeof (buildTabsFunction) === 'function')
						{
							buildTabsFunction(link);
						}

					}, "No, Open in Read-Only", "This Case Not Assigned to You",
					"modalConfirmDlg", 1);
			}
		}
		else	
		{
			// not digital review, assign the case to the user
			jsPAL.cmdBar.caseId = id;
			jsPAL.cmdBar.doAssignToMe(true);
		}
	}
	else
	{
		// case is not assigned to a group, open the case
		if (typeof (buildTabsFunction) === 'function')
		{
			buildTabsFunction(link);
		}
	}
};
/**
 * Bind the keypress handlers of Case Assembly and Consult Request for dynamically changing the tab text
 * @param tabPanelDiv The tab panel div to search for inputs in
 * @param tabDiv The tab div, e.g. #('#MainTabs')
 * @param caseId The id of the case
 */
jsPAL.bindCaseTabTextFields = function(tabPanelDiv, tabDiv, caseId)
{
	// each array element in SystemParms.CaseCaptionFields is a object that
	// looks like this:
	// {tablename: case, fieldcolumn: patientfullname}
	for ( var i = 0; i < SystemParms.CaseCaptionFields.length; i++)
	{
		var elementType = ':input';
		if (SystemParms.CaseCaptionFields[i].tablename === 'Case' && SystemParms.CaseCaptionFields[i].fieldcolumn === 'PatientGender')
		{
			elementType = 'select'; // patient gender is a select, not an input
		}
		var selector = elementType + '[tablename=' + SystemParms.CaseCaptionFields[i].tablename + '][columnname=' + SystemParms.CaseCaptionFields[i].fieldcolumn + ']';
		var element = tabPanelDiv.find(selector);
		if (element.length > 0)
		{
			var readonly = element.attr('readonly')
			if (undefined === readonly || '' === readonly)
			{
				element.on('keyup', function()
				{
					jsPAL.updateCaseTabText(caseId, tabDiv);
				}).on('change', function()
				{
					jsPAL.updateCaseTabText(caseId, tabDiv);
				});
			}
		}
		if (SystemParms.CaseCaptionFields[i].tablename === 'Case' && (SystemParms.CaseCaptionFields[i].fieldcolumn == 'PatientFullName'))
		{
			// PatientFullName is built from PatientName and PatientFirstName
			tabPanelDiv.find(':input[tablename=Case][columnname=PatientName]').on('keyup', function()
			{
				jsPAL.updateCaseTabText(caseId, tabDiv);
			}).on('change', function()
			{
				jsPAL.updateCaseTabText(caseId, tabDiv);
			});
			tabPanelDiv.find(':input[tablename=Case][columnname=PatientFirstName]').on('keyup', function()
			{
				jsPAL.updateCaseTabText(caseId, tabDiv);
			}).on('change', function()
			{
				jsPAL.updateCaseTabText(caseId, tabDiv);
			});
		}
	}
};
/**
 * Get grid row for a given case id. The grid must be contained in the #MainTabs div
 * @param caseId The id of the case
 * @return Html table row for the case 
 */
jsPAL.getCaseGridRow = function(caseId)
{
	var row = jsPAL.getTabPanelDiv($('#MainTabs'), 0).find('.ui-jqgrid-btable[tablename="Case"]').find('.jqgrow[id=' + caseId + ']');
	return row;
};
/**
 * Select the results tab for a case
 * @param caseId is the case id
 * @param workflowTabDiv is the id of the div containing the workflow tabs, e.g.
 */ 
jsPAL.selectResultsTab = function(caseId, workflowTabDiv)
{
	var caseTabDiv = null; // tab div for this case
	var mainTabsDiv = $('#MainTabs'); // main tabs div
	var mainTabs = jsPAL.getTabsForDiv(mainTabsDiv); // main tabs row
	// search the main tabs row to see if this case is already open, if it is
	// switch to that main tab.
	// skip the first tab since it is a grid tab
	for ( var i = 1; i < mainTabs.length; i++)
	{
		// get the tab panel div for this main tab
		var tabPanelDiv = jsPAL.getTabPanelDiv(mainTabsDiv, i);
		// is it for this case?
		if (tabPanelDiv.attr('tablename') === 'case' && (tabPanelDiv.attr('primarykey') == caseId))
		{
			// found the main tab for this case, select that tab
			jsPAL.selectTab(mainTabsDiv, i);
			caseTabDiv = tabPanelDiv;
		}
	}
	if (caseTabDiv === null)
	{
		// didn't find the main tab for the case, the user must not have opened
		// it yet,
		// so open the tab for the case

		// get the div for the jqGrid
		var gridDiv = jsPAL.getTabPanelDiv(mainTabsDiv, 0);
		// find the grid <tr> for the case
		var tr = gridDiv.find('tr[id=' + caseId + ']');
		if (tr.length > 0)
		{
			// found the tr, now find the action icon to open the case
			var action = tr.find("a.Edit");
			if (action.length === 0)
			{
				action = tr.find("a.View");
			}
			if (action.length > 0)
			{
				// found the <a>, click it to open the case
				action.click();
				// the assumption here is that the newly opened tab is the last
				// tab in mainTabsDiv
				mainTabs = jsPAL.getTabsForDiv(mainTabsDiv).length;
				// get the div for the case's tab
				caseTabDiv = jsPAL.getTabPanelDiv(mainTabsDiv, length - 1);
			}
		}
	}
	if (caseTabDiv !== null)
	{
		// find the tab row for the workflow tabs
		var workflowTabs = caseTabDiv.find($(workflowTabDiv));
		if (workflowTabs.length > 0)
		{
			// find the Results tab
			var index = jsPAL.getTabIndexByText(workflowTabs, 'Results');
			if (index > -1)
			{// select the Results tab for this case
				jsPAL.selectTab(workflowTabs, index);
			}
		}
	}
};

/**
* 	Show Healthcare help
*/ 
jsPAL.ShowHelpHC = function()
{
	var helpMapIdKey = 'Healthcare';
	if (undefined !== SystemParms.HelpMapWorkflowId && '' !== SystemParms.HelpMapWorkflowId)
	{
		// get work flow help map id, e.g. CA
		helpMapIdKey = SystemParms.HelpMapWorkflowId;
	}
	// Special case for Healthcare admin mode
	if (true === SystemParms.AdminMode)
	{
		helpMapIdKey = 'Admin';
	}
	else
	{
		var mainTabs = $('#MainTabs');
		if (jsPAL.getSelectedTabIndex(mainTabs) > 0)
		{
			// special case for Search, the key is 'Search'
			if (jsPAL.getSelectedTabText(mainTabs) === 'Search')
			{
				helpMapIdKey = 'Search';
			}
		}
	}
	// map key to its numeric value
	var helpMapId = helpMap_HC.mapIdKey(helpMapIdKey);
	// for details on using the _csh start file:
	// 	http://www.wvanweelden.eu/robohelp/context_sensitivity_in_webhelp/methods_for_calling_Webhelp/_csh_start_file
	window.open(
		 '/Help/HealthCare/Index_csh.htm#' + helpMapId + ',withnavpane=true', // withnavpane=true shows the toolbar and navigation pane
		 '_HealthcareHelpPopup',		// window name
		 'left=250,top=60,width=750,height=700'	// parameters
		 );
};

/**
 * Cleans Error Message recieved from Data Server
 * @param msg The message string
 */
function CleanUpDSErrorMessage(msg)
{
	var newmsg ='' ;
	var msg_part = 'Check DataServer.log file for more details';
	var pattern = /(Failed)(.*?)(:)/g;
	if (msg != '')
	{
		 newmsg = msg.replace(msg_part, '').replace(pattern,'');
	}
	return newmsg;
}

/*
Call this after ajax post on dropdown_box reload
need the binding for the hover event on dropdown_box list.
*/
function SearchHover()
{
	$(".search_hover").hover(function()
	{		
		$(this).addClass('search_hover_highlighter');
	},
	 function()
	{
		$(this).removeClass('search_hover_highlighter');
	});
}
